import template from './leave_restriction_rule.html';
import tr from '../../lib/default-translator.js';

class LeaveRestrictionRuleViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.rule_name = ko.observable();
		this.description = ko.observable();
		this.parsed_description = ko.observable();
		this.customization_rules = ko.observableArray();
		this.holiday_types = ko.observableArray();
		this.intervalOptions = ko.observableArray([
			{ 'name': 'Hour(s)', 'db_value': 'hour' },
			{ 'name': 'Day(s)', 'db_value': 'day' },
			{ 'name': 'Month(s)', 'db_value': 'month' },
			{ 'name': 'Year(s)', 'db_value': 'year' }
		]);
	};

	close()
	{
		this.dialog.close();
	}

	async update_and_save(v, e)
	{
		let post_url = '/admin/save_leave_restriction_rule';
		let payload = {
			'customization_rules': v.customization_rules(),
			'leave_restriction_rule_id': this.dialog.bindings.data
		};

		for (let a = 0; a < payload.customization_rules.length; a++)
		{
			let customization_rule = payload.customization_rules[a];

			if (customization_rule.type == 'integer')
			{
				let tempValue = Number(customization_rule.value);
				if (customization_rule.value === undefined || customization_rule.value === null || (String(customization_rule.value)).trim() == '' || isNaN(tempValue) || tempValue < 0)
				{
					Grape.alerts.alert({type: 'error', message: tr('Please make sure you use only positive numbers.'), title: 'Validation Failure'});
					return;
				}
			}
		}

		let res = await Grape.fetches.postJSON(post_url, payload);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully updated rule.'), title: tr('Success', 'Success')});
			this.dialog.updateData();
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
		}
		else if (res.error)
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error', 'Error') });
	};
};

class LeaveRestrictionRulePage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveRestrictionRuleViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		let res = await Grape.fetches.getJSON('/api/record', { table: 'holiday_types', limit: 100 });
		if (res.status != 'ERROR')
		{
			this.viewModel.holiday_types(res.records);
			this.updateData();
		};
	};

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_leave_restriction_rules',
			schema: 'savanna',
			limit: 1,
			filter: [{
				value: this.bindings.data,
				operand: '=',
				field: 'leave_restriction_rule_id'
			}]
		});
		
		if (res.status !== 'ERROR')
		{
			this.viewModel.rule_name(res.records[0].rule_name);
			this.viewModel.parsed_description(res.records[0].parsed_description);

			let description = new String(res.records[0].description);
			let myfields = res.records[0].customization_fields;
			let obj = parseLeaveRestrictionRule(description, myfields);

			this.viewModel.customization_rules(obj.customization_rules);
			this.viewModel.description(obj.description);
		}
	};
};

export default {
	name: 'LeaveRestrictionRule',
	dialog_class: LeaveRestrictionRulePage,
	template: template,
	template_filename: 'translation/dialogs/leave_restriction_rule',
	provider: 'ps'
};
